// extracted by mini-css-extract-plugin
module.exports = {"input":"jgp-3T3l5","label":"jgp-1uzWp","hint":"jgp-Cg1Cw"};